import React from 'react';

function DataIntHub() {
  return (
    <div className="container">
      <p>Data Integration</p>
    </div>
  );
}

export default DataIntHub;
